<template>
    <div class="complaints">
        <servicesList></servicesList>
        <div class="complaints_info">
            <div class="complaints_info_content" v-if="isLogin">
                <label>{{$t('complaints_type')}}</label>
                <div class="complaint_types">
                    <select name="tag" class="sel" v-model="form.tag">
                        <option value="">--{{$t('select')}}--</option>
                        <option :value="n.tid" v-for="(n,i) in tagList">{{n.name}}</option>
                    </select>
                </div>
                <label>{{$t('phone')}}</label>
                <input type="text" name="IdCard" readonly v-model="form.phone">
                <div class="complaints_img">
                    <img src="../../assets/images/service/p.png" alt="">
                    <span>{{form.name}}</span>
                </div>
                <textarea :placeholder="$t('placeholder_suggestion')" v-model.trim="form.massage" v-focus="focusTrue"></textarea>
                <span class="complaints_btn" @click="submitComplaints()">{{$t('sure_submit')}}</span>
            </div>
            <span class="complaints_fail" @click="loginLink()" v-else>
                {{$t('please_login')}}
            </span>
        </div>
        <div class="tag">
            <form @submit.prevent action="#" class="tag_search">
                <input type="search" :placeholder="$t('placeholder_key')" v-model="tagsName" @blur="searchIos"
                       @keypress="searchAndroid">
                <i></i>
            </form>
            <ul class="careers_name">
                <li v-for='(n,i) in this.tagList' @click="getComplaints(n.tid,'','1')" :key="i">{{n.name}}</li>
            </ul>
        </div>
        <div v-if="isEmptyData">
            <complaintsList v-for="(n,i) in reply_list" :cList="n" :key="i"></complaintsList>
            <div v-html="pagination" class="paging_numbers" ref="pagination"></div>
        </div>
        <div style='width: 100%;text-align: center;margin: 75px 0 ;' v-else><img
                src='../../assets/images/no_page.png' alt='' width="160"></div>
    </div>
</template>

<script>
import complaintsList from "../../components/services/complaintsList";
import servicesList from "../../components/services/servicesList";


export default {
  name: "complaints",
  components: {
    complaintsList,
    servicesList
  },
  inject: ["showMsg"],
  data: function() {
    return {
      isLogin: false,
      reply_list: [],
      tagList: [],
      isEmptyData: true,
      tagsName: "",
      userObj: "",
      focusTrue: true,
      form: {
        tag: "",
        phone: "",
        name: "",
        massage: ""
      },
      pagination: "",
      tag_id: ""
    };
  },
  directives: {
    focus: {
      inserted(el, { value }) {
        //inserted只有第一次聚焦
        //页面渲染时，第一个input框聚焦，
        // console.log(el, {value});
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function() {
    this.getUser();
    this.getComplaints(this.tag_id, this.tagsName, "1");
    // this.$store.commit("set_current_index", 6);
    this.$store.commit("set_current_index", 5);
    this.$store.commit("set_current", 5);
    this.$store.commit("set_title", "nav.service");
  },
  methods: {
    getUser: function() {
      this.$http({
        type: "POST",
        url: this.weburl + "Home/User/checkLogin",
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        dataType: "json"
      })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.result) {
              this.isLogin = true;
              this.getUserObj();
            } else {
              this.isLogin = false;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getComplaints(id, keys, p) {
      this.tag_id = id;
      this.tagsName = keys;
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/Serve/getGuestbook?p=" + p,
        dataType: "json",
        data: {
          tag_id: this.tag_id,
          content: this.tagsName
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            console.log(res.data.result);
            this.tagList = res.data.result.tag;
            this.reply_list = res.data.result.list;
            this.pagination = res.data.result.show;
            this.isEmptyData = res.data.result.hasOwnProperty("list");
            if (res.data.result.show) {
              setTimeout(() => {
                this.GetDom();
              }, 1000);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    searchIos() {
      //ios点击完成失去焦点搜索
      this.getComplaints("", this.tagsName, "1");
    },
    searchAndroid(event) {
      //android点击搜索，未能失去焦点，故失去焦点事件无法触发，单可以调用键盘事件处理
      if (event.keyCode == 13) {
        //如果按的是enter键 13是enter
        event.preventDefault(); //禁止默认事件（默认是换行）
        this.getComplaints("", this.tagsName, "1");
      }
    },
    loginLink() {
      this.$router.push({ path: "/login" });
    },
    getUserObj() {
      this.userObj = JSON.parse(localStorage.getItem("userInfo"));
      this.form.phone = this.userObj.mobile;
      if (this.nickname == "") {
        this.form.name = "cl_" + Math.floor(Math.random() * 9000);
      } else {
        this.form.name = this.userObj.nickname;
      }
    },
    GetDom() {
      var DOM = this.$refs.pagination;
      var a_dom = DOM.getElementsByTagName("a");
      var that = this;
      if(a_dom){
          for (let i = 0; i < a_dom.length; i++) {
              a_dom[i].onclick = function() {
                  document.body.scrollTop = document.documentElement.scrollTop = 0;
                  that.getComplaints(that.tag_id, that.tagsName, this.dataset.p);
              };
          }
      }

    },
    submitComplaints() {
      if (this.form.tag === "") {
        this.showMsg("请选择投诉类型");
        return false;
      }
      if (this.form.massage === "") {
        this.showMsg("提交的问题不能为空");
        return false;
      }
      this.focusTrue = false;
      this.$http({
        method: "post",
        url: this.weburl + "home/Serve/postGuestbook",
        dataType: "json",
        data: this.form
      })
        .then(res => {
          if (res.data.status === 1) {
            this.showMsg(res.data.msg);
            this.form.massage = "";
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
    /*getPage(p) {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                this.$http({
                    method: "post",
                    url: this.weburl + "/home/Serve/getGuestbook?p=" + p,
                    dataType: "json",
                    data:{
                        tag_id: this.tag_id,
                        content:this.tagsName
                    }
                })
                    .then(res => {
                        if (res.data.status == 1) {
                            this.pagination = res.data.result.show;
                            setTimeout(() => {
                                this.GetDom();
                            }, 1000)

                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },*/
  },
  mounted() {
    setTimeout(() => {
      this.GetDom();
    }, 1000);
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

.complaints {
  width: @width;
  .complaints_info {
    width: 90%;
    padding: 0 5%;
    margin: auto;
    .border-bottom(5px; @bg);
    label {
      position: relative;
      width: 22%;
      height: @height;
      display: inline-block;
      line-height: @height;
      &:before {
        content: "*";
        top: -2px;
        left: -10px;
        font-size: @font - 0.1;
        color: @brick_red;
      }
    }
    input,
    .complaint_types {
      display: inline-block;
      width: 78%;
      height: @height;
      line-height: @height;
      .border-bottom;
      position: relative;
      font-size: @font - 0.1;
    }
    .complaint_types {
      select {
        .img;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        font-size: @font - 0.1;
      }
      &:after {
        content: "";
        right: 0;
        background: url("@{sprite}") no-repeat -79px -8px;
        background-size: 308px auto;
        top: 10%;
        width: 12px;
        height: 41px;
        pointer-events: none;
        transform: rotate(90deg);
      }
    }
    @height: 55px;
    .complaints_img {
      height: @height;
      line-height: @height;
      margin-bottom: 20px;
      .border-bottom;
      font-size: 0.8rem;
      img {
        width: 10%;
        float: left;
        margin: 10px;
      }
    }
    textarea {
      width: 100%;
      .border-bottom;
      height: 100px;
      font-size: 1.4rem;
    }
    .complaints_btn,
    .complaints_fail {
      .btn;
      width: 75%;
      margin: 10px auto;
      display: block;
    }
    .complaints_fail {
      background: @subject_color;
    }
  }
}

.tag {
  .box-sizing;
  width: @width;
  padding: 20px 20px 0;
}

.tag_search {
  width: @width;
  height: @height + 2;
  .box-sizing;
  padding-left: 17px;
  .border-radius(25px);
  .border(1px; solid; tint(@word, 50%));
  margin-bottom: 15px;
  input {
    width: 90%;
    height: @height;
    float: left;
    line-height: @height;
  }
  i {
    float: left;
    margin-top: 6px;
    width: 10%;
    height: 23px;
    background: url(../../assets/images/xuebi_28.png) no-repeat -1px -14px;
    background-size: 23px auto;
  }
}

@height: 38px;
.careers_name {
  display: flex;
  flex-wrap: wrap;
  li {
    padding: 7px 10px;
    background: darken(@bg, 5%);
    color: @word;
    font-size: 0.8rem;
    margin-right: 5px;
    .border-radius(20px);
    margin-bottom: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
<style>
@import "../../assets/css/pagination.css";
</style>
